import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router";
import "./campaign_configuration.css";
import api from "../../../config/api";
import config from "../../../config/config";
import { Dialog } from "@progress/kendo-react-dialogs";
import BackIcon from "../../../assets/communication/Back.svg";
import { useDispatch, useSelector } from "react-redux";
import { ADMIN_TOOLS_CAMPAIGN_CONFIGURATION_LIST, REWARDS_INVENTORY_LIST } from "../../../routes";
import { Button } from "@progress/kendo-react-buttons";
import { Icon } from "@progress/kendo-react-common";
import NextIcon from "../../../assets/communication/NextIcon.svg";
import { Loader } from "@progress/kendo-react-indicators";
import { checkPermission, getUserPermission } from "../../../config/permission_helper";
import { PermissionDeninedPage } from "../../../components/reusableItems/permission_denined";
import { TextBox } from "@progress/kendo-react-inputs";
import { getCurrentLoggedInSessionTokenWithPromise } from "../../../config/userPool";
import { createAndUpdateCampaignRewardProvider, fetchRewardProviderDetail } from "../../../store/campaign_configuration";
import { DropDownList } from "@progress/kendo-react-dropdowns";
const { CAMPAIGN_CONFIGURATION_IMAGE_UPLOAD_ENDPOINT } = config.api_endpoint;

export const CreateUpdateCampaignRewardProvider = () => {

  const navigate = useNavigate();
  let { search } = useLocation();
  const dispatch = useDispatch();
  const query = new URLSearchParams(search);
  const FileRef = useRef();

  const [imageLoading, setImageLoading] = useState(false);

  const [id, setId] = useState(
    query.get("id", "")
  );

  const userPermissions = getUserPermission();

  const AddPermission = checkPermission(
    userPermissions,
    "gamifications.create_campaign"
  );

  const [file, setFile] = useState("");

  const [loading, setLoading] = useState(false);
  const [showRequiredFieldError, setShowRequiredFieldError] = useState(false);


  const [error, setError] = useState({
    name: "",
    campaign_type: "",
    image_s3_key: "",
  });


  const [editData, setEditData] = useState({
    name: "",
    campaign_type: "",
    image_s3_key: "",
    image_url: ""
  });


  useEffect(() => {
    getData();
  }, []);


  const getData = async () => {
    setLoading(true);
    if (id) {
      dispatch(fetchRewardProviderDetail(id)).then((res) => {


        let payload = res.payload;


        setEditData({
          ...editData,
          name: payload.name,
          campaign_type: payload.campaign_type,
          image_s3_key: payload.image_s3_key || "",
          image_url: payload.image_url  || ""
        });

        setLoading(false);

      });
    } else {
      setLoading(false);

    }
  };


  const checkMandatoryFields = () => {

    const { name } = editData;



    if (!name
    ) {
      console.error("All date and time fields must be filled.");
      setShowRequiredFieldError(true);
      return true;
    }



  };



  const handleSubmit = () => {
    if (checkMandatoryFields()) return;


    setLoading(true);

    let updatedData = { ...editData };

    if (id) {  // Ensures id is neither null nor empty
      updatedData.id = id;
    }


    dispatch(createAndUpdateCampaignRewardProvider({ data: updatedData, id })).then((res) => {
      const { payload } = res;
      if (payload.status === "success") {
        const saved_id = payload.data?.id || id;
        getData();

        setLoading(false);

        redirectListing();

      } else {
        setLoading(false);



      }
    });



  };

  const redirectListing = () => {
    navigate(`${ADMIN_TOOLS_CAMPAIGN_CONFIGURATION_LIST}?tab=reward_provider`);
  }





  const uploadFile = () => {

    FileRef.current.click();
  };

  const ImageHandler = () => {
    let url =
      id
        ? file === ""
          ? editData.image_url !== "" && editData.image_url
          : URL.createObjectURL(file)
        : file !== "" && URL.createObjectURL(file);
    let name =
      id
        ? file === ""
          ? editData.image_url !== "" && editData.image_url.split("/")[5].split("?")[0]
          : file.name
        : file !== "" && file.name;
    return (
      <div className="inventory_create_file_main_box">
        <div className="inventory_create_file_child_box">
          <div>
            <img src={url} className="inventory_create_file_image" />
          </div>
          <div className="inventory_create_file_child_box_text">{name}</div>
        </div>
        <div>
          {AddPermission && (<span
            class="k-icon k-font-icon k-i-delete inventory_create_file_child_box_delete_icon"
            onClick={() => {
              setFile("");
              setEditData({
                ...editData,
                image_s3_key: "",
                image_url: ""
              });
            }}
          />
          )}

        </div>
      </div>
    );
  };


  const onUploadFile = async (e) => {
    setImageLoading(true);
    const token = await getCurrentLoggedInSessionTokenWithPromise();
    const extension_ =
      e.type === "" ? e.name.split(".")[1] : e.type.split("/")[1];
    api
      .post(
        CAMPAIGN_CONFIGURATION_IMAGE_UPLOAD_ENDPOINT,
        JSON.stringify({
          extensions: [extension_],
        }),
        token
      )
      .then((res) => {
        console.log(res);
        api.postDiff(res.data[0].presigned_url, e).then((res1) => {
          console.log(res1);
          if (res1 === 200) {
            setFile(e);
            setEditData({
              ...editData,
              image_s3_key: res.data[0].key,
            });
            setImageLoading(false);
          } else {
            alert("An error occured while uploading file! Please try again!");
          }
        });
      });
  };


  return (
    <>
      {AddPermission ? (
        <div style={{ height: "calc(100% - 75px)" }}>



          {showRequiredFieldError && (
            <Dialog
              className="information-details-alert-form"
              title={"Alert"}
              onClose={() => setShowRequiredFieldError(false)}
            >
              <p
                style={{
                  margin: "25px",
                  textAlign: "center",
                }}
              >
                Please fill in all the required fields.
              </p>
            </Dialog>
          )}

          {imageLoading && (
            <Loader
              type="converging-spinner"
              style={{
                width: "100%",
                height: "calc(100% - 76px)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "#ffffff4d",
                position: "absolute",
                zIndex: "999",
              }}
            />
          )}

          {(loading) && (
            <Loader
              type="converging-spinner"
              style={{
                width: "100%",
                height: "calc(100% - 75px)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "#ffffff4d",
                position: "absolute",
                zIndex: "999",
              }}
            />
          )}

          <div className="campaign-configuration-body">
            <div className="campaign-configuration-add-header" >
              <div className="back-title-group" onClick={(e) => redirectListing()}>
                <img src={BackIcon} className="back-icon" />
                <span className="back-text">Back</span>
              </div>
            </div>
          </div>

          <div className="campaign-configuration-container">
            <div className="main-campaign-configuration">
              <div className="campaign-configuration-scroll-box">
                <div>
                  <div className="campaign-configuration_create_item_main_box">
                    <div className="campaign-configuration-header">
                      Reward Provider
                    </div>

                    <div className="campaign-configuration_create_item_main_box_title">
                      Provider Name
                    </div>
                    <div>
                      <TextBox
                        className="campaign-configuration_create_item_main_box_field"
                        value={editData.name}
                        disabled={!AddPermission}
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            name: e.target.value,
                          })
                        }
                      />
                      {error.name !== "" && (
                        <div className="campaign-configuration_create_error_text">
                          {error.name}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="campaign-configuration_create_item_main_box">
                    <div className="campaign-configuration_create_item_main_box_title">
                      Campaign Type
                    </div>
                    <div className="campaign-configuration_add_dropdown">
                      <DropDownList
                        data={["Digital", "Physical"]}
                        value={editData.campaign_type}
                        size={"large"}
                        onChange={(e) => {

                          setEditData({
                            ...editData,
                            campaign_type: e.target.value,
                          })
                          setCampaignType(e.target.value);
                        }}
                        iconColor="#73007D"
                        iconClassName="k-icon k-font-icon k-i-arrow-chevron-down"
                      />
                      {error.campaign_type !== "" && (
                        <div className="campaign-configuration_create_error_text">
                          {error.campaign_type}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="campaign-configuration_create_item_main_box">
                    <div className="campaign-configuration_create_upload_main_box">
                      <div className="campaign-configuration_create_item_main_box_title">
                        Provider Image
                        <span className="campaign-configuration_create_item_main_box_title_span">
                          (Max 1 file, no more than 5MB each)
                        </span>
                      </div>
                    </div>
                    {!file && editData.image_s3_key === "" && (<div className="campaign-configuration_nodata_view">
                      <div className="campaign-configuration_nodata_title"> No image</div>
                      {AddPermission && (
                        <div className="campaign-configuration_create_upload_button_box">
                          <div onClick={uploadFile} >
                            <div>+ Upload Image</div>
                            <input
                              accept={[
                                "image/jpeg",
                                "image/png",
                                "image/jpg",
                                //   "application/pdf",
                                //   "application/msword",
                              ]}
                              ref={FileRef}
                              type="file"
                              hidden
                              onClick={(e) => (e.target.value = "")}
                              onChange={(e) => onUploadFile(e.target.files[0])}
                            />
                          </div>
                        </div>
                      )}
                    </div>)}
                    {id
                      ? editData.image_s3_key !== "" && <ImageHandler />
                      : file !== "" && <ImageHandler />}
                  </div>





                </div>



              </div>

            </div>

            <div className="campaign-configuration-footer">
              <div className="footer-left-btn-groups"></div>

              <div className="campaign-configuration-footer-right">
                <Button
                  className="footer-previous-btn font-family-poppins"
                  onClick={() => {
                    redirectListing();
                  }}
                >
                  Cancel
                </Button>

                <Button
                  className="footer-next-btn"
                  onClick={(e) => {
                    handleSubmit();
                  }}
                >
                  Submit
                </Button>
              </div>



            </div>
          </div>


        </div>
      ) : (
        <PermissionDeninedPage
          height={"calc(100% - 76px)"}
          title={"Sorry, You don't have permission to access this page!"}
        />
      )}
    </>
  );
};
